<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 0pt; top: 1.11pt"
        >填寫問卷時，請先確認上頁所列印之</span
      >
      <span
        class="wcspan wctext002"
        style="font-size: 11pt; left: 176pt; top: 1.11pt"
        >個人基本資料</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 242pt; top: 1.11pt"
        >如：</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 264pt; top: 1.11pt"
        >名字</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 286pt; top: 1.11pt"
        >、</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 297pt; top: 1.11pt"
        >身分證號碼</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 352pt; top: 1.11pt"
        >、</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 363pt; top: 1.11pt"
        >生日</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 385pt; top: 1.11pt"
        >、</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 396pt; top: 1.11pt"
        >電話</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 418pt; top: 1.11pt"
        >、</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 429pt; top: 1.11pt"
        >地址</span
      >
      <span
        class="wcspan wctext001"
        style="font-size: 11pt; left: 451pt; top: 1.11pt"
        >，是否正確。</span
      >
      <div
        class="wcdiv"
        style="
          left: 176pt;
          top: 11.85pt;
          width: 66pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 264pt;
          top: 11.85pt;
          width: 22pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 297pt;
          top: 11.85pt;
          width: 55pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 363pt;
          top: 11.85pt;
          width: 22pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 396pt;
          top: 11.85pt;
          width: 22pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 429pt;
          top: 11.85pt;
          width: 22pt;
          height: 0pt;
          border-top: solid 0.75pt #000000;
        "
      >
        <br />
      </div>
      <div class="wcdiv" style="top: 14.3pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: -0.05pt;
            width: 143.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          <br />
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 1.61pt"
          >第一部份：生活型態</span
        >
      </div>
      <div class="wcdiv" style="top: 35.1pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >1.請問您目前有無吸菸?</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 131.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 143.75pt; top: 1.26pt"
          >{{
            ifq("1.請問您目前有無吸菸?", "0.無(不吸菸)", "■", "□")
          }}0.無(不吸菸)</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 51.34pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{ ifq("1.請問您目前有無吸菸?", "1.已戒", "■", "□") }}1.已戒，</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 62.5pt; top: 1.26pt"
          >1-1.已戒菸{{ ifq("1-1.已戒菸", "0.未滿6個月", "■", "□") }}0.未滿6個月
          {{ ifq("1-1.已戒菸", "1.6個月以上", "■", "□") }}1.6個月以上。</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 67.59pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("1.請問您目前有無吸菸?", "2.朋友敬菸或應酬才吸菸", "■", "□")
          }}2.朋友敬菸或應酬才吸菸&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 83.84pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "1.請問您目前有無吸菸?",
              "3.菸齡10年以下，每天少於20支(平均一天約吸一包菸【含以下】)",
              "■",
              "□"
            )
          }}3.菸齡10年以下，每天少於20支(平均一天約吸一包菸【含以下】)</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 100.09pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "1.請問您目前有無吸菸?",
              "4.菸齡10年以下，每天20支以上(平均一天約吸一包菸以上)",
              "■",
              "□"
            )
          }}4.菸齡10年以下，每天20支以上(平均一天約吸一包菸以上)&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 116.34pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "1.請問您目前有無吸菸?",
              "5.菸齡超過10年，每天少於20支(平均一天約吸一包菸【含以下】)",
              "■",
              "□"
            )
          }}5.菸齡超過10年，每天少於20支(平均一天約吸一包菸【含以下】)</span
        >
      </div>
      <div class="wcdiv" style="left: 143.75pt; top: 132.58pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "1.請問您目前有無吸菸?",
              "6.菸齡超過10年，每天20支以上(平均一天約吸一包菸以上)",
              "■",
              "□"
            )
          }}6.菸齡超過10年，每天20支以上(平均一天約吸一包菸以上)</span
        >
      </div>
      <div class="wcdiv" style="top: 148.83pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >1-2.如果您有吸菸，請問您是否有戒菸的意願？</span
        >
      </div>
      <div class="wcdiv" style="top: 165.08pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq("1-2.如果您有吸菸，請問您是否有戒菸的意願？", "0.否", "■", "□")
          }}0.否。</span
        >
      </div>
      <div class="wcdiv" style="top: 181.33pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq(
              "1-2.如果您有吸菸，請問您是否有戒菸的意願？",
              "1.是，我可能在6個月內戒菸",
              "■",
              "□"
            )
          }}1.是，我可能在6個月內戒菸。</span
        >
      </div>
      <div class="wcdiv" style="top: 197.58pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq(
              "1-2.如果您有吸菸，請問您是否有戒菸的意願？",
              "2.是，我準備1個月內就想戒菸",
              "■",
              "□"
            )
          }}2.是，我準備1個月內就想戒菸。</span
        >
      </div>
      <div class="wcdiv" style="top: 213.82pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >2.請問您目前有無使用電子煙？{{
            ifq("2.請問您目前有無使用電子菸?", "0.無", "■", "□")
          }}0.無(請跳第3題)</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 281.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 293.75pt; top: 1.26pt"
          >{{
            ifq("2.請問您目前有無使用電子菸?", "1.過去有", "■", "□")
          }}1.過去有</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 368.75pt; top: 1.26pt"
          >{{
            ifq("2.請問您目前有無使用電子菸?", "2.現在有", "■", "□")
          }}2.現在有</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 230.07pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >2-1.請問電子煙來源是?&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 246.32pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("2-1.請問電子煙來源是?", "0.實體店家", "■", "□")
          }}0.實體店家</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 87.5pt; top: 1.26pt"
          >{{
            ifq("2-1.請問電子煙來源是?", "1.網路平台", "■", "□")
          }}1.網路平台</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 162.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 175pt; top: 1.26pt"
          >{{
            ifq("2-1.請問電子煙來源是?", "2.親朋好友贈與", "■", "□")
          }}2.親朋好友贈與</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 275pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 287.5pt; top: 1.26pt"
          >{{ ifq("2-1.請問電子煙來源是?", "3.其他", "■", "□") }}3.其他
          {{ ifqOther("2-1.請問電子煙來源是?", "3.其他") }}</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 262.57pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >2-2.如為網路平台，請問由何種平台購入?</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 278.82pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "2-2.如為網路平台，請問由何種平台購入?",
              "0.Facebook",
              "■",
              "□"
            )
          }}0.Facebook</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 93.75pt; top: 1.26pt"
          >{{
            ifq("2-2.如為網路平台，請問由何種平台購入?", "1.Line", "■", "□")
          }}1.Line</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 143.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 162.5pt; top: 1.26pt"
          >{{
            ifq(
              "2-2.如為網路平台，請問由何種平台購入?",
              "2.蝦皮拍賣",
              "■",
              "□"
            )
          }}2.蝦皮購物</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 237.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 256.25pt; top: 1.26pt"
          >{{
            ifq(
              "2-2.如為網路平台，請問由何種平台購入?",
              "3.露天拍賣",
              "■",
              "□"
            )
          }}3.露天拍賣</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 331.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 350pt; top: 1.26pt"
          >{{
            ifq("2-2.如為網路平台，請問由何種平台購入?", "4.Pchome", "■", "□")
          }}4.Pchome</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 412.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 431.25pt; top: 1.26pt"
          >{{
            ifq("2-2.如為網路平台，請問由何種平台購入?", "5.Yahoo", "■", "□")
          }}5.Yahoo</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 295.06pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("2-2.如為網路平台，請問由何種平台購入?", "6.其他", "■", "□")
          }}6.其他
          {{
            ifqOther("2-2.如為網路平台，請問由何種平台購入?", "6.其他")
          }}</span
        >
      </div>
      <div class="wcdiv" style="top: 311.31pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >3.請問您是否覺得吸入二手菸?
          {{ ifq("3.請問您是否覺得吸入二手菸?", "0.從不", "■", "□") }}0.從不
          {{ ifq("3.請問您是否覺得吸入二手菸?", "1.偶爾", "■", "□") }}1.偶爾
          {{
            ifq("3.請問您是否覺得吸入二手菸?", "2.經常", "■", "□")
          }}2.經常</span
        >
      </div>
      <div class="wcdiv" style="top: 327.56pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >4.請問您目前有無喝酒?
          {{
            ifq("4.請問您目前有無喝酒?", "0.無(不喝酒)", "■", "□")
          }}0.無(不喝酒)</span
        >
      </div>
      <div class="wcdiv" style="left: 136.25pt; top: 343.81pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("4.請問您目前有無喝酒?", "1.偶爾喝酒或應酬才喝", "■", "□")
          }}1.偶爾喝酒或應酬才喝</span
        >
      </div>
      <div class="wcdiv" style="left: 136.25pt; top: 360.06pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("4.請問您目前有無喝酒?", "2.經常喝酒(每週超過3次)", "■", "□")
          }}2.經常喝酒(每週超過3次)</span
        >
      </div>
      <div class="wcdiv" style="top: 376.3pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >5.請問您目前有無嚼檳榔?
          {{
            ifq("5.請問您目前有無嚼檳榔?", "0.無(不嚼檳榔)", "■", "□")
          }}0.無(不嚼檳榔)</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 392.55pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{ ifq("5.請問您目前有無嚼檳榔?", "1.已戒", "■", "□") }}1.已戒</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 408.8pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("5.請問您目前有無嚼檳榔?", "2.偶爾會嚼或應酬才嚼", "■", "□")
          }}2.偶爾會嚼或應酬才嚼</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 425.05pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "5.請問您目前有無嚼檳榔?",
              "3.嚼10年以下，每天少於20顆(經常嚼或習慣嚼)",
              "■",
              "□"
            )
          }}3.嚼10年以下，每天少於20顆(經常嚼或習慣嚼)</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 441.3pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "5.請問您目前有無嚼檳榔?",
              "4.嚼10年以下，每天20顆以上(經常嚼或習慣嚼)",
              "■",
              "□"
            )
          }}4.嚼10年以下，每天20顆以上(經常嚼或習慣嚼)</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 457.54pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "5.請問您目前有無嚼檳榔?",
              "5.嚼超過10年，每天少於20顆(經常嚼或習慣嚼)",
              "■",
              "□"
            )
          }}5.嚼超過10年，每天少於20顆(經常嚼或習慣嚼)</span
        >
      </div>
      <div class="wcdiv" style="left: 150pt; top: 473.79pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "5.請問您目前有無嚼檳榔?",
              "6.嚼超過10年，每天20顆以上(經常嚼或習慣嚼)",
              "■",
              "□"
            )
          }}6.嚼超過10年，每天20顆以上(經常嚼或習慣嚼)</span
        >
      </div>
      <div class="wcdiv" style="top: 490.04pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >6.請問您是否有刷牙的習慣？{{
            ifq("6.請問您是否有刷牙的習慣？", "0.無", "■", "□")
          }}0.無{{
            ifq("6.請問您是否有刷牙的習慣？", "1.只有早上或晚上", "■", "□")
          }}1.只有早上或晚上{{
            ifq("6.請問您是否有刷牙的習慣？", "2.早晚皆有", "■", "□")
          }}2.早晚皆有{{
            ifq("6.請問您是否有刷牙的習慣？", "3.早晚及三餐後皆有", "■", "□")
          }}3.早晚及三餐後皆有</span
        >
      </div>
      <div class="wcdiv" style="top: 506.29pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >7.請問您是否有每月量體重的習慣？{{
            ifq("7.請問您是否有每月量體重的習慣？", "0.無", "■", "□")
          }}0.無
          {{
            ifq("7.請問您是否有每月量體重的習慣？", "1.有", "■", "□")
          }}1.有</span
        >
      </div>
      <div class="wcdiv" style="top: 522.54pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >8.請問您有無這樣活動(例如：散步、健走或打掃、伸展)，每次持續10分鐘以上？</span
        >
      </div>
      <div class="wcdiv" style="top: 538.78pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq(
              "8.請問您有無這樣活動(例如：散步、健走或打掃、伸展)，每次持續10分鐘以上？",
              "0.無",
              "■",
              "□"
            )
          }}0.無</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 50pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 62.5pt; top: 1.26pt"
          >{{
            ifq(
              "8.請問您有無這樣活動(例如：散步、健走或打掃、伸展)，每次持續10分鐘以上？",
              "1.有",
              "■",
              "□"
            )
          }}1.有【續問】</span
        >
      </div>
      <div class="wcdiv" style="top: 555.03pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 37.5pt; top: 1.26pt"
          >1-1.每天分段</span
        >
        <span
          class="wcspan wctext002"
          style="font-size: 12.5pt; left: 112.5pt; top: 1.26pt"
          >累積</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 137.5pt; top: 1.26pt"
          >30分鐘以上(含)？
          {{
            ifq("1-1.每天分段累積30分鐘以上(含)？", "0.無", "■", "□")
          }}0.無</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 281.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 293.75pt; top: 1.26pt"
          >{{
            ifq("1-1.每天分段累積30分鐘以上(含)？", "1.有", "■", "□")
          }}1.有</span
        >
      </div>
      <div class="wcdiv" style="top: 571.28pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 37.5pt; top: 1.26pt"
          >1-2.每週5次以上？{{
            ifq("1-2.每週5次以上？", "0.無(未達每週150分鐘)", "■", "□")
          }}0.無(未達每週150分鐘)</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 287.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 300pt; top: 1.26pt"
          >{{
            ifq("1-2.每週5次以上？", "1.有(每週達150分鐘)", "■", "□")
          }}1.有(每週達150分鐘)</span
        >
      </div>
      <div class="wcdiv" style="top: 587.53pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >9.請問您開車或騎車或乘坐汽機車嗎? 【選1、2、3者續問】</span
        >
      </div>
      <div class="wcdiv" style="top: 603.78pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq("9.請問您開車或騎車或乘坐汽機車嗎?", "0.都沒有", "■", "□")
          }}0.都沒有(請跳第10題)</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 150pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 168.75pt; top: 1.26pt"
          >{{
            ifq("9.請問您開車或騎車或乘坐汽機車嗎?", "1.開車", "■", "□")
          }}1.開車</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 218.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 237.5pt; top: 1.26pt"
          >{{
            ifq("9.請問您開車或騎車或乘坐汽機車嗎?", "2.騎車", "■", "□")
          }}2.騎車</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 287.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 306.25pt; top: 1.26pt"
          >{{
            ifq("9.請問您開車或騎車或乘坐汽機車嗎?", "3.都有", "■", "□")
          }}3.都有</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 375pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您開車或騎車或乘坐汽機車嗎?",
              "4.僅乘坐汽機車",
              "■",
              "□"
            )
          }}4.僅乘坐汽機車</span
        >
      </div>
      <div class="wcdiv" style="top: 620.02pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >9-1.您有使用安全帶或戴安全帽的情形是：</span
        >
      </div>
      <div class="wcdiv" style="top: 636.27pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq("9-1.您有使用安全帶或戴安全帽的情形是：", "0.不用", "■", "□")
          }}0.不用</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 62.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 81.25pt; top: 1.26pt"
          >{{
            ifq("9-1.您有使用安全帶或戴安全帽的情形是：", "1.偶爾用", "■", "□")
          }}1.偶爾用</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 143.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 162.5pt; top: 1.26pt"
          >{{
            ifq("9-1.您有使用安全帶或戴安全帽的情形是：", "2.每次用", "■", "□")
          }}2.每次用&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="top: 652.52pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >9-2.假如您參加應酬喝酒後，您會：【不喝酒者免填】</span
        >
      </div>
      <div class="wcdiv" style="top: 668.77pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
          >{{
            ifq(
              "9-2.假如您參加應酬喝酒後，您會：【不喝酒者免填】",
              "0.自己開(騎)車回家",
              "■",
              "□"
            )
          }}0.自己開(騎)車回家</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 137.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 156.25pt; top: 1.26pt"
          >{{
            ifq(
              "9-2.假如您參加應酬喝酒後，您會：【不喝酒者免填】",
              "1.搭車回家",
              "■",
              "□"
            )
          }}1.搭車回家</span
        >
      </div>
      <div class="wcdiv" style="top: 685.02pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >10.您是否出現咳嗽超過二週的情形？{{
            ifq("10.您是否出現咳嗽超過二週的情形？", "0.否", "■", "□")
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 243.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 256.25pt; top: 1.26pt"
          >{{
            ifq("10.您是否出現咳嗽超過二週的情形？", "1.是", "■", "□")
          }}1.是</span
        >
      </div>
      <!-- <div class="wcdiv" style="top: 701.26pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >11.過去兩週，您是否感覺情緒低落、沮喪或沒有希望？{{
            ifq(
              "11.過去兩週，您是否感覺情緒低落、沮喪或沒有希望？",
              "0.否",
              "■",
              "□"
            )
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 343.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >{{
            ifq(
              "11.過去兩週，您是否感覺情緒低落、沮喪或沒有希望？",
              "1.是",
              "■",
              "□"
            )
          }}1.是</span
        >
      </div> -->
      <!-- <div class="wcdiv" style="top: 717.51pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >12.過去兩週，您是否感覺做事失去興趣或樂趣？{{
            ifq(
              "12.過去兩週，您是否感覺做事失去興趣或樂趣？",
              "0.否",
              "■",
              "□"
            )
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 306.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 318.75pt; top: 1.26pt"
          >{{
            ifq(
              "12.過去兩週，您是否感覺做事失去興趣或樂趣？",
              "1.是",
              "■",
              "□"
            )
          }}1.是</span
        >
      </div> -->
      <div class="wcdiv" style="top: 701.26pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >11.過去一年內是否跌倒？{{
            ifq(
              ["13.過去一年內是否跌倒？", "11.過去一年內是否跌倒？"],
              "0.沒有跌倒",
              "■",
              "□"
            )
          }}0.沒有跌倒
          {{
            ifq(
              ["13.過去一年內是否跌倒？", "11.過去一年內是否跌倒？"],
              "1.單次跌倒",
              "■",
              "□"
            )
          }}1.單次跌倒
          {{
            ifq(
              ["13.過去一年內是否跌倒？", "11.過去一年內是否跌倒？"],
              "2.反覆跌倒",
              "■",
              "□"
            )
          }}2.反覆跌倒</span
        >
      </div>
      <div class="wcdiv" style="top: 717.51pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >12.整體而言，您的視力問題是否造成日常生活上的困擾？{{
            ifq(
              [
                "14.整體而言，您的視力問題是否造成日常生活上的困擾？",
                "12.整體而言，您的視力問題是否造成日常生活上的困擾？",
              ],
              "0.否",
              "■",
              "□"
            )
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 368.75pt; top: 1.26pt"
          >{{
            ifq(
              [
                "14.整體而言，您的視力問題是否造成日常生活上的困擾？",
                "12.整體而言，您的視力問題是否造成日常生活上的困擾？",
              ],
              "1.是",
              "■",
              "□"
            )
          }}1.是</span
        >
      </div>
    </div>
    <div class="wcdiv" style="left: 298.35pt; top: 50.5pt">
      <div
        class="wcdiv"
        style="left: -8.22pt; top: -12.07pt; width: 119px; height: 53px"
      >
        <img
          alt="健檢問卷圖示"
          src="https://myfiles.space/user_files/136203_8f8e61a5d9d46e28/1668417319_2023-new/1668417319_2023-new-2.svg"
        />
      </div>
      <div class="wcdiv" style="clip: rect(5.2pt, 79.33pt, 22.73pt, 1.6pt)">
        <div class="wcdiv" style="left: 8.8pt; top: 5.2pt">
          <span
            class="wcspan wctext002"
            style="font-size: 14pt; left: 0pt; top: 1.41pt"
            >請先確認</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  mixins: [MixinBigQuiz],
};
</script>
